var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-layout"},[_c('van-button',{attrs:{"block":""},on:{"click":_vm.onClick}},[_vm._v("点击返回主页")]),_c('img',{staticClass:"not-found-img",attrs:{"src":require("../../assets/404/404.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }